import * as React from 'react';
import { connect } from 'react-redux';

import Spinner from 'components/spinner/Spinner';

import StatisticsCustomizableOverlap from 'modules/statistics/components/customizable-overlap/StatisticsCustomizableOverlap';

import {
  fetchAllInfluencersInCampaign,
  fetchCustomizableAudienceOverlapCampaign,
  resetCustomizableAudienceOverlap
} from 'modules/statistics/reducers/statistics-customizable-audience-overlap';

type OwnProps = {
  campaignId: number,
  offerState: string
};

type StateProps = {
  isLoadingInfluencers: boolean
};

type DispatchProps = {
  dispatchFetchAllInfluencers: () => Promise<void>,
  dispatchResetCustomizableAudienceOverlap: () => Promise<void>,
  dispatchFetchCustomizableAudienceOverlap: (a: number) => Promise<void>
};

type Props = OwnProps & StateProps & DispatchProps;

const StateStatisticsCustomizableOverlap = (props: Props) => {
  const {
    campaignId,
    offerState,
    isLoadingInfluencers,
    dispatchFetchAllInfluencers,
    dispatchResetCustomizableAudienceOverlap,
    dispatchFetchCustomizableAudienceOverlap
  } = props;

  React.useEffect(() => {
    dispatchFetchAllInfluencers();

    return () => {
      dispatchResetCustomizableAudienceOverlap();
    };
  }, [campaignId, offerState, dispatchFetchAllInfluencers]);

  return (
    <div
      className="statistics-customizable-overlap"
      data-qa="statistics-customizable-overlap"
    >
      {isLoadingInfluencers ?
        <Spinner
          position="inline"
          size="small"
          color="light"
        /> :
        <StatisticsCustomizableOverlap
          fetchCustomizableAudienceOverlap={dispatchFetchCustomizableAudienceOverlap}
        />
      }
    </div>
  );
};

const mapStateToProps = ({ statisticsCustomizableAudienceOverlap: { isLoadingInfluencers } }): StateProps => ({
  isLoadingInfluencers
});

const mapDispatchToProps = (
  dispatch,
  {
    campaignId,
    offerState
  }: OwnProps
): DispatchProps => ({
  dispatchFetchCustomizableAudienceOverlap: (influencerId: number) => (
    dispatch(fetchCustomizableAudienceOverlapCampaign(campaignId, offerState, influencerId))
  ),

  dispatchResetCustomizableAudienceOverlap: () => (
    dispatch(resetCustomizableAudienceOverlap())
  ),

  dispatchFetchAllInfluencers: (): Promise<void> => dispatch(fetchAllInfluencersInCampaign(campaignId, offerState))
});

export default connect(mapStateToProps, mapDispatchToProps)(StateStatisticsCustomizableOverlap);
